import { useMemo } from "react";
import { Optional } from "../../../types";
import { Text } from "../../text";
import styles from "./featured-offer-brand.module.css";

export type FeaturedOfferBrandProps = {
  size?: Optional<"small">;
};

export function FeaturedOfferBrand({ size }: FeaturedOfferBrandProps) {
  const className = useMemo(() => {
    if (size === "small") {
      return `${styles.Container} ${styles.Small}`;
    }

    return styles.Container;
  }, [size]);

  return (
    <div className={className}>
      <Text color="#fff" variant="body-semibold-2xsmall">
        Oferta Destaque
      </Text>
    </div>
  );
}
